$(function(){
  setupSidebar();
  setupFooter();
  setupHelpPopUp();
  setupDashRounds();
  setupWhyImages();
  setupLoadingNumbers();
  setupSlowlyFade();
  setupErrorLogging();
  setupContestGame();
  setupContestResultsAndCountdown();
  loadSvg();
  setupFlashMessages();
  // setupPublicContestFormToggle();
  setupSounds();
  setupSwitchTruncatedText();


  if (jQuery.fn.tooltip !== undefined) {
    $('[data-toggle="tooltip"]').tooltip();
  }
  if (jQuery.fn.popover !== undefined) {
    $('[data-toggle="popover"]').popover({trigger: "hover"});
  }

  if ($('.textareaToCalculate').length > 0) {  // on print page only
    setupTextAreaRowCalculation();
  }

  if ($('#copyToClipboardBtn').length > 0) {
    copyToClipboard();
  }

  if ($('.showHideLink').length > 0) {
    setupShowHideLink();
  }
  
})


let showMistakesInAfterPlay = () => {
  
  $('#afterPlay-screen').hide();
  $('#mistakes-table').show();

  $('.link-showMistakes').hide();
  $('.link-hideMistakes').show();
  
}

let hideMistakesInAfterPlay = () => {
  
  $('#afterPlay-screen').show();
  $('#mistakes-table').hide();

  $('.link-showMistakes').show();
  $('.link-hideMistakes').hide();
}



function insertDashToInputAfterCharacters(id) {

  $('#' + id).keyup(function(e) {

      let inputText = $(this).val();
      const lastChar = inputText[inputText.length - 1];

      if(e.key === 'Backspace') 
      { 
        inputText = (lastChar === '-') ? 
                      (inputText.substring(0, inputText.length - 2)) : 
                      (inputText = inputText.substring(0, inputText.length - 1));

        $(this).val(inputText);
      }



      const text = $(this).val().match(/.{1,4}/g) ?? [];

      let newText = "";

      text.forEach((value, index) => 
      {
        value = value.replace('-', '');
        value = value.replace('–', '');
      
        newText = (value.length === 4) ? 
                    (newText = newText + value + '-') : 
                    (newText = newText + value);
      });
 
      $(this).val(newText);
    }
  );

  $('#' + id).keydown(function(e) { 
    if(e.key === 'Backspace') {
      e.preventDefault();
    }

  });

}

function setupShowHideLink() {

  $('.showHideLink').click(function() 
  {
    id = $(this).attr('data-id');

    if($(this).hasClass('hideText')) 
    {
      $(this).removeClass('hideText');
      $(this).addClass('showText');

      $("#arrow-" + id).removeClass('glyphicon-chevron-up')
      $("#arrow-" + id).addClass('glyphicon-chevron-down')
    } 
    else if($(this).hasClass('showText')) 
    {
      $(this).removeClass('showText');
      $(this).addClass('hideText');

      $("#arrow-" + id).removeClass('glyphicon-chevron-down')
      $("#arrow-" + id).addClass('glyphicon-chevron-up')

    }
    
  });

}

function getCurrentDate(withTime) {
  
  var d = new Date();

  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var minutes = d.getMinutes();
  var seconds = d.getSeconds();

  var date = d.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;


  if(withTime == true) 
  {
    return date + ' ' + 
      (hours < 10 ? '0' : '') + hours + ':' + 
      (minutes < 10 ? '0' : '') + minutes + ':' + 
      (seconds < 10 ? '0' : '') + seconds;
  } 
  else 
  {
    return date;
  }

}

function convertHMS(value) {
  const sec = parseInt(value, 10); 
  var hours   = Math.floor(sec / 3600); // get hours
  var minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
  var seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return {hours: hours, minutes: minutes, seconds: seconds} 
}

function setupSounds() {
  $('a.playSound').click(function(e) {
    e.preventDefault();

    $($(this).attr('data-src'))[0].play();
  });
}


function setupPublicContestFormToggle(formName = 'PublicContestForm') {

  const toggleTextSettings = function(form, formName) {

    const textSourceOption = $('#frm-' + formName + '-form-textSource option:selected').val();

    if (textSourceOption == 'custom') 
    {
      $('.textSourceStep').addClass('required');
      
      $('.customTextDiv', form).show();
      $('.customTextTr', form).show();
      $('.allowedLettersTr', form).hide();
    }
    else 
    {
      $('.textSourceStep').removeClass('required');

      $('.customTextDiv', form).hide();
      $('.customTextTr', form).hide();
      $('.allowedLettersTr', form).show();
    }    
  }

  var toggleDate = function(form, type) {

    if ($('input[name=contest' + type + 'Setting]:checked', form).val() == 'time') {
      $('.' + type  + 'SettingTr', form).show();
    }
    else {
      $('.' + type + 'SettingTr', form).hide();
    }    
  }


  var hideEndDateTimeOption = function(form, startSettingValue) {
    
    if(startSettingValue == 'manualy') 
      {
        $('input[name=contestEndSetting][value=time]').prop('checked', false);
        $('input[name=contestEndSetting][value=manualy]').prop('checked', true);

        $('.contestEndSetting_time').hide();

        toggleDate(form, 'End');
      } 
      else 
      {
        $('.contestEndSetting_time').show();
      }
  }



  $('.contestForm').each(function() {
    
    const t = this;
    $('#frm-' + formName +'-form-textSource', this).change(function() {
      toggleTextSettings(t, formName);  
    });

    if($('#frm-' + formName +'-form-textSource', this).val() === 'random') {
      toggleTextSettings(this, formName);  
    }



    $('input[name=contestStartSetting]', this).change(function() {
      startSettingValue = $('input[name=contestStartSetting]:checked', t).val();
      hideEndDateTimeOption(t, startSettingValue);

      toggleDate(t, 'Start');  
    });
    
    startSettingValue = $('input[name=contestStartSetting]:checked', t).val();
    hideEndDateTimeOption(t, startSettingValue);
    
    toggleDate(this, 'Start');  


    $('input[name=contestEndSetting]', this).change(function() {
      toggleDate(t, 'End');  
    });
    
    toggleDate(this, 'End'); 
    
  });
}

function setupSwitchTruncatedText() {

  $('.switch-truncate-text').each(function() 
  {
    textElement = $($(this).attr('data-text'));
  
    if(textElement.width() < 470) {
      $(this).hide();
    } else {
      $(this).show();
    }

  })

  $('.switch-truncate-text').click(function() {
    
    isTruncated = $(this).attr('data-isTruncated');
    textElement = $($(this).attr('data-text'));
    textClass = $(this).attr('data-textClass');

    if(isTruncated == 1) 
    {
      textElement.removeClass(textClass);
      $(this).attr('data-isTruncated', 0);

      $(this).text($(this).attr('data-less'));
    } 
    else 
    {
      textElement.addClass(textClass);
      $(this).attr('data-isTruncated', 1);

      $(this).text($(this).attr('data-more'));
    }

  }); 

}


function setupFlashMessages() {
  $(".flashMessage").not('.permanent').delay(7000).fadeTo(1000, 0, function(){
    $(".flashMessage").not('.permanent').remove();
  });
}

function loadSvg() {
  var url = $('body').attr('data-svgUrl');

  $.get(url, function(data) {
    var div = document.createElement("div");
    div.classList.add("hidden");
    div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
    document.body.insertBefore(div, document.body.childNodes[0]);
  });
}


function setupContestGame() {
  var game = $('.contestGame');
  if (game.length == 0) return;

  var secondsToEnd = parseInt($('.contestEndTime').attr('data-secondsToEnd'));
  if (secondsToEnd > 604800) {    // == 60*60*24*7    // bugfix in case of too big integer
    secondsToEnd = 604800;
  }

  var messageAfterEnd = game.attr('data-messageAfterEnd');

  setTimeout(function() {
    $('.link-restartGame')
        .removeClass('display-block').hide()
        .parent()
          .append('<div class="text-red w-200">'+messageAfterEnd+'</div>');
  }, (secondsToEnd) * 1000);

  setTimeout(function() {
    $('.contestGame .gameCanvas').hide();
    $('.contestGame .afterContestText').show();
  }, secondsToEnd * 1000);
  
}


function setupContestResultsAndCountdown() {

  
  if ($('.contestEndTime').length == 0) return;

  if ($('.contestStartTime').attr('data-secondsToStart') == "") {
    return;   // zadna automaticka aktualizace (rucni start souteze)
  }


  var secondsToStart = parseInt($('.contestStartTime').attr('data-secondsToStart'));
  var secondsToEnd = parseInt($('.contestEndTime').attr('data-secondsToEnd'));

  // start activities now? (not before the contest begins!)
  if (secondsToStart > 0) {
    setTimeout(function() {
      $('a.contestResultsRefreshLink').addClass('keepRefreshing');
      setupContestResultsRefreshing(secondsToEnd - secondsToStart);
      setupContestEndCountdown(secondsToStart);
      // $('.contestRunningWrapper').removeClass('hidden');
    }, secondsToStart * 1000);    
  }
  else {
    setupContestResultsRefreshing(secondsToEnd);
    setupContestEndCountdown();
  }

}

function setupContestResultsRefreshing(secondsToEnd) {

  var resultsRefreshLink = $('a.contestResultsRefreshLink.keepRefreshing');
  if (resultsRefreshLink.length == 0) return;

  // get parameters
  var keepsRefreshingAfterContestEnd = parseInt(resultsRefreshLink.attr('data-keepsRefreshingAfterContestEnd'));
  var refreshInterval = parseInt(resultsRefreshLink.attr('data-refreshInterval'));
  if (refreshInterval < 10) {
    refreshInterval = 10;
  }
  // set the refresh interval
  var interval = setInterval(function() {
      $('a.contestResultsRefreshLink.keepRefreshing').click();
    }, refreshInterval * 1000);
  
  if (secondsToEnd > 604800) {    // == 60*60*24*7    // bugfix in case of too big integer
    secondsToEnd = 604800;
  }


  // set the end of the interval
  if (!isNaN(secondsToEnd)) {   // we know the end of the contest
    setTimeout(function() {
      clearInterval(interval);
    }, (secondsToEnd + keepsRefreshingAfterContestEnd) * 1000);
  }
}

function setupContestEndCountdown(skipSeconds) {
  var contestEndTimeEl = $('.contestEndTime');

  if (contestEndTimeEl.attr('data-secondsToEnd') == "") {
    return;   // // we do NOT know the end of the contest
  }

  var secondsToEnd = parseInt(contestEndTimeEl.attr('data-secondsToEnd'));
  
  if (skipSeconds) {
    secondsToEnd -= skipSeconds;  // if this was initiated with a delay (waiting until the contest starts, we need to adjust seconds to end accordingly)
  }
  --secondsToEnd;   // -1, because the interval below runs for the first time after 1 second

  var interval = setInterval(function() {
    if (secondsToEnd < 0) {
      $('.countdownWrapper', contestEndTimeEl)
        .addClass('text-red text-bold')
        .text(contestEndTimeEl.attr('data-messageAfterEnd'));
      $('.contestRunningWrapper').addClass('hidden');
      
      clearInterval(interval);
      
      return;
    }

    if (secondsToEnd <= 3600) {
      $('.countdownWrapper', contestEndTimeEl).removeClass('hidden');
      $('.countdown', contestEndTimeEl).text(secondsToTimeString(secondsToEnd));
    }
    
    contestEndTimeEl.attr('data-secondsToEnd', --secondsToEnd);
  }, 1000);
}

function secondsToTimeString(timeInSeconds) {
    var seconds = padLeft(timeInSeconds % 60);
    var minutes = padLeft(Math.floor(timeInSeconds/60) % 60);
    var hours = padLeft(Math.floor(timeInSeconds/3600));

    return hours + ':' + minutes + ':' + seconds;
}

function padLeft(number, char, size) {
  char = char || '0';
  size = size || 2;

  var string = number.toString();
  var charsMissing = size - string.length;
 
  for (var i=0; i<charsMissing; ++i) {
    string = char + string;
  }

  return string;
}

function setupErrorLogging(){
  window.onerror = function(message, source, line, column, errorObj){
    var dataToSend = { 
        message: message,
        source: source,
        line: line,
        column: column,
        url: window.location.href,
        userAgent: navigator.userAgent
      };
      
    if(errorObj !== undefined) {//so it won't blow up in the rest of the browsers
        dataToSend.stack = errorObj.stack;
      
        if(errorObj.stack !== undefined) {
          dataToSend.errorObj = errorObj;
        }
    }


    $.ajax({ 
      method: "POST",
      url: errorLogUrl,
      data: dataToSend
    })
  }
}

function copyToClipboard() {

  $('.copyToClipboard').click(function() {
    
    input = $('#copyToClipboardInput');
    link = input.val();

    $(input).select();
    document.execCommand("copy");

    if(navigator.clipboard) {
      navigator.clipboard.writeText(link);
    }

    input.tooltip('show');

    setTimeout(function(){
      input.tooltip('hide');
    }, 2000);
  });

  $('.copyToClipboard2').click(function() {
    
    input = $('#copyToClipboardInput2');
    link = input.val();

    $(input).select();
    document.execCommand("copy");

    if(navigator.clipboard) {
      navigator.clipboard.writeText(link);
    }

    input.tooltip('show');

    setTimeout(function(){
      input.tooltip('hide');
    }, 2000);
  });
}

function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function setupSidebar(){
  $('.section-chooser').each(function(){
    $(this).data('startY', parseInt($(this).css("top").substring(0,$(this).css("top").indexOf("px"))));
  });

  $(window).scroll(function(){
    $('.section-chooser').each(function(){
      var offset = $(this).data('startY') + $(document).scrollTop();
      var max = $(this).parent('*').height() - $(this).height();
      if(offset > max) {
        return;
      }
      $(this).css({
        top: offset
      });
    });
  });
}

function setupFooter() {
  if($('img.comm').length > 0){
    $('.footer-comm').addClass('imgset');
  }
}

function setupHelpPopUp(){
  $('.help-popup').hover(function(){
    $(this).find('.popup-dialog').toggleClass('show-dialog').parent('.help-popup').toggleClass('active');
  });
}

function setupDashRounds(){
  $('.dash-round').on('mouseleave', function(){
    if(!$(this).find('.round').hasClass('disable')) $('.flashing').removeClass('off');
  });
  $('.dash-round').on('mouseenter', function(){
    if(!$(this).find('.round').hasClass('disable')) $('.flashing').addClass('off');
  });
}

function setupWhyImages(){
  $(window).scroll(function(){
    $('.whyImg').each(function(){
      if($(this).isOnScreen()){
        $(this).addClass('come');
      }
    });
  });
}

function setupSlowlyFade(){
  $('.slowly-fade').each(function(){
    var t = $(this)
    if(t.hasClass('slowly-fade-delay')) setTimeout(function(){t.addClass('hide-slowly-fade')},4000);
    else t.addClass('hide-slowly-fade');
  });
}

function removeValueFromArray(val, arr){
  var index = arr.indexOf(val)
  if(index >= 0){
    arr.splice(index, 1)
  }
}

function removeDiacritics(str){
  str = str
          .replace(/ě/g, 'ecaron')
          .replace(/š/g, 'scaron')
          .replace(/č/g, 'ccaron')
          .replace(/ř/g, 'rcaron')
          .replace(/ž/g, 'zcaron')
          .replace(/ý/g, 'yacute')
          .replace(/á/g, 'aacute')
          .replace(/í/g, 'iacute')
          .replace(/é/g, 'eacute')
          .replace(/ú/g, 'uacute')
          .replace(/ů/g, 'ucircle')
          .replace(/ď/g, 'dcaron')
          .replace(/ť/g, 'tcaron')
          .replace(/ň/g, 'ncaron')
          .replace(/ó/g, 'oacute')
          .replace(/Ě/g, 'ecaron-capital')
          .replace(/Š/g, 'scaron-capital')
          .replace(/Č/g, 'ccaron-capital')
          .replace(/Ř/g, 'rcaron-capital')
          .replace(/Ž/g, 'zcaron-capital')
          .replace(/Ý/g, 'yacute-capital')
          .replace(/Á/g, 'aacute-capital')
          .replace(/Í/g, 'iacute-capital')
          .replace(/É/g, 'eacute-capital')
          .replace(/Ú/g, 'uacute-capital')
          .replace(/Ů/g, 'ucircle-capital')
          .replace(/Ď/g, 'dcaron-capital')
          .replace(/Ť/g, 'tcaron-capital')
          .replace(/Ň/g, 'ncaron-capital')
          .replace(/Ó/g, 'oacute-capital')
          .replace(/ľ/g, 'lcaron')
          .replace(/ô/g, 'ovokan')
          .replace(/ä/g, 'adots')
          .replace(/Ľ/g, 'lcaron-capital')
          .replace(/Ô/g, 'ovokan-capital')
          .replace(/Ä/g, 'adots-capital')
  return str
}

function addDiacritics(str){
  str = str
          .replace(/ecaron/g, 'ě')
          .replace(/scaron/g, 'š')
          .replace(/ccaron/g, 'č')
          .replace(/rcaron/g, 'ř')
          .replace(/zcaron/g, 'ž')
          .replace(/yacute/g, 'ý')
          .replace(/aacute/g, 'á')
          .replace(/iacute/g, 'í')
          .replace(/eacute/g, 'é')
          .replace(/uacute/g, 'ú')
          .replace(/ucircle/g, 'ů')
          .replace(/dcaron/g, 'ď')
          .replace(/tcaron/g, 'ť')
          .replace(/ncaron/g, 'ň')
          .replace(/oacute/g, 'ó')
          .replace(/ecaron\-capital/g, 'Ě')
          .replace(/scaron\-capital/g, 'Š')
          .replace(/ccaron\-capital/g, 'Č')
          .replace(/rcaron\-capital/g, 'Ř')
          .replace(/zcaron\-capital/g, 'Ž')
          .replace(/yacute\-capital/g, 'Ý')
          .replace(/aacute\-capital/g, 'Á')
          .replace(/iacute\-capital/g, 'Í')
          .replace(/eacute\-capital/g, 'É')
          .replace(/uacute\-capital/g, 'Ú')
          .replace(/ucircle\-capital/g, 'Ů')
          .replace(/dcaron\-capital/g, 'Ď')
          .replace(/tcaron\-capital/g, 'Ť')
          .replace(/ncaron\-capital/g, 'Ň')
          .replace(/oacute\-capital/g, 'Ó')
          .replace(/lcaron/g, 'ľ')
          .replace(/ovokan/g, 'ô')
          .replace(/adots/g, 'ä')
          .replace(/lcaron\-capital/g, 'Ľ')
          .replace(/ovokan\-capital/g, 'Ô')
          .replace(/adots\-capital/g, 'Ä')
  return str
}

function setupTextAreaRowCalculation() {
  $('.textareaToCalculate').on("change keyup paste", function() {
    var rowsCount = $(this).val().split(/\r*\n/).filter(function(el){return el!==''}).length;
    $('.textAreaRowsCount').text(rowsCount);
  });
}